import Nav from 'react-bootstrap/lib/Nav'
import NavItem from 'react-bootstrap/lib/NavItem'
import PropTypes from 'prop-types'
import React from 'react'
import Tab from 'react-bootstrap/lib/Tab'
import Table from 'react-bootstrap/lib/Table'
import {css} from 'glamor'

import Tabs from '../../../../components/tabs'
import Video from '../../../../components/video'

const style = {
  tabs: css({
    marginBottom: 0
  })
}

const SizingChart = ({sizeChart}) => (
  <Tabs defaultActiveKey="measurements" id="sizingChart">
    <div>
      <Nav bsStyle="pills" bsClass="nav-tabs" {...style.tabs}>
        <NavItem eventKey="measurements">Measurements</NavItem>
        <NavItem eventKey="instructions">Instructions</NavItem>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="measurements">
          <Table>
            <tbody>
              <tr>
                <th />
                {sizeChart.map((size, i) => (
                  <th key={i}>{size.Size}</th>
                ))}
              </tr>
              {sizeChart[0].Measurement1Name ? (
                <tr>
                  <th>{sizeChart[0].Measurement1Name}</th>
                  {sizeChart
                    .map((size) => size.Measurement1Value)
                    .map((m, i) => (
                      <td key={i}>{m}</td>
                    ))}
                </tr>
              ) : null}
              {sizeChart[0].Measurement2Name ? (
                <tr>
                  <th>{sizeChart[0].Measurement2Name}</th>
                  {sizeChart
                    .map((size) => size.Measurement2Value)
                    .map((m, i) => (
                      <td key={i}>{m}</td>
                    ))}
                </tr>
              ) : null}
              {sizeChart[0].Measurement3Name ? (
                <tr>
                  <th>{sizeChart[0].Measurement3Name}</th>
                  {sizeChart
                    .map((size) => size.Measurement3Value)
                    .map((m, i) => (
                      <td key={i}>{m}</td>
                    ))}
                </tr>
              ) : null}
              {sizeChart[0].Measurement4Name ? (
                <tr>
                  <th>{sizeChart[0].Measurement4Name}</th>
                  {sizeChart
                    .map((size) => size.Measurement4Value)
                    .map((m, i) => (
                      <td key={i}>{m}</td>
                    ))}
                </tr>
              ) : null}
            </tbody>
          </Table>
        </Tab.Pane>
        <Tab.Pane eventKey="instructions">
          <Table>
            <tbody>
              <tr>
                <th colSpan="2">Women</th>
              </tr>
              <tr>
                <th>Bust</th>
                <td>
                  Measure around your body, under your arms, at the fullest part
                  of your chest.
                </td>
              </tr>
              <tr>
                <th>Chest Width</th>
                <td>
                  Lay garment flat. Measure 1&#8243; below armhole. Measure
                  across chest width, from seam to seam. There is an allowance
                  plus or minus &#189;&#8243; per size.
                </td>
              </tr>
              <tr>
                <th>Length</th>
                <td>
                  Measure from the high shoulder point, down to the bottom of
                  the top. There is an allowance plus or minus 1&#8243; per
                  size.
                </td>
              </tr>
              <tr>
                <th>Sleeve</th>
                <td>
                  Measure length from center back neck, over point of shoulder,
                  past the elbow, to the wrist. There is an allowance plus or
                  minus 1&#8243; per size.
                </td>
              </tr>
              <tr>
                <th>Waist</th>
                <td>
                  Measure around and above your hips, but below your ribs at the
                  smallest part.
                </td>
              </tr>
              <tr>
                <th>Waist Relaxed</th>
                <td>Lay garment flat. Measure across the top of waistline.</td>
              </tr>
              <tr>
                <th>Inseam</th>
                <td>
                  Measure from crotch seam to bottom of the hem of the pants or
                  shorts.
                </td>
              </tr>
              <tr>
                <th colSpan="2">Men</th>
              </tr>
              <tr>
                <th>Chest</th>
                <td>
                  Measure around your body, under your arms, at the fullest part
                  of your chest.
                </td>
              </tr>
              <tr>
                <th>Chest Width</th>
                <td>
                  Lay garment flat. Measure 1&#8243; below armhole. Measure
                  across chest width, from seam to seam. There is an allowance
                  plus or minus &#189;&#8243; per size.
                </td>
              </tr>
              <tr>
                <th>Length</th>
                <td>
                  Measure from the high shoulder point, down to the bottom of
                  the top. There is an allowance plus or minus 1&#8243; per
                  size.
                </td>
              </tr>
              <tr>
                <th>Sleeve</th>
                <td>
                  Measure length from center back neck, over point of shoulder,
                  past the elbow, to the wrist. There is an allowance plus or
                  minus 1&#8243; per size.
                </td>
              </tr>
              <tr>
                <th>Waist</th>
                <td>
                  Measure around and above your hips, but below your ribs at the
                  smallest part.
                </td>
              </tr>
              <tr>
                <th>Waist Relaxed</th>
                <td>Lay garment flat. Measure across the top of waistline.</td>
              </tr>
              <tr>
                <th>Inseam</th>
                <td>
                  Measure from crotch seam to bottom of the hem of the pants or
                  shorts.
                </td>
              </tr>
            </tbody>
          </Table>
        </Tab.Pane>
      </Tab.Content>
    </div>
  </Tabs>
)

SizingChart.propTypes = {
  sizeChart: PropTypes.array.isRequired
}

export default SizingChart
